<template>
    <div class="tabs_nav">
        <BtnTab :class="{'has-error': !formValidity[0]}" btn-id="FormStep1" :active-tab="isActive('FormStep1')" @btnTab:Clicked="changeTab">{{ $t('modules.refs.topbar.tabName') }}</BtnTab>
        <BtnTab :class="{'has-error': !formValidity[1]}" btn-id="FormStep2" :active-tab="isActive('FormStep2')" @btnTab:Clicked="changeTab">{{ $t('modules.refs.topbar.tabAssociatedRef') }}</BtnTab>
        <BtnTab :class="{'has-error': !formValidity[2]}" btn-id="FormStep3" :active-tab="isActive('FormStep3')" @btnTab:Clicked="changeTab">{{ $t('modules.refs.topbar.tabScores') }}</BtnTab>
        <BtnTab :class="{'has-error': !formValidity[3]}" btn-id="FormStep4" :active-tab="isActive('FormStep4')" @btnTab:Clicked="changeTab">{{ $t('modules.refs.topbar.tabCoeff') }}</BtnTab>
    </div>
</template>

<script>
export default {
    name: 'TopbarTabs',
    components: {},
    data(){
        return {}
    },
    computed: {
        formValidity(){
            return this.$store.state.RefStore.formValidity
        },
        formStepsName(){
            return this.$store.state.RefStore.formStepsName
        },
        currentStepComponent(){
            return this.$store.state.RefStore.formStepsName[this.$store.state.RefStore.formCurrentStep]
        },
        formCurrentStep(){
            return this.$store.state.RefStore.formCurrentStep
        }
    },
    methods: {
        changeTab(tabName){
            const tabIndex = this.formStepsName.indexOf(tabName)
            if(tabIndex != -1){
                this.$store.commit('RefStore/changeCurrentStep', { index: tabIndex})
            }
        },
        isActive(tabName){
            return this.currentStepComponent == tabName
        }
    }
}
</script>
<style lang="scss">
    .tabs_nav{
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: stretch;
        padding-left: 70px;
        a{
            line-height: 60px;
        }
    }
</style>
